<div class="lpx-mobile-navbar-container">
  <nav class="lpx-mobile-navbar app-tabbar" [class.menu-open]="activeMenu === 'navbar'">
    @for (tab of navTabs; track tab.link) {
      <a
        class="app-tab"
        [routerLink]="tab.link"
        routerLinkActive="selected"
        [routerLinkActiveOptions]="{ exact: tab.link === '/' }"
        (click)="closeMenu()"
      >
        @if (tab.icon) {
          <lpx-icon class="app-tab-icon" [iconClass]="tab.icon"></lpx-icon>
        }
        <span class="app-tab-text">{{ tabLabel(tab) | abpLocalization }}</span>
      </a>
    }

    <a
      class="app-tab lpx-mobile-hamburger"
      [class.selected]="activeMenu === 'navbar'"
      [ngClass]="toggleClass"
      (click)="toggleNavbarMenu()"
    >
      <i
        class="app-tab-icon fa"
        [class.fa-bars]="activeMenu !== 'navbar'"
        [class.fa-times]="activeMenu === 'navbar'"
        aria-hidden="true"
      ></i>
      <span class="app-tab-text">{{ 'RegisterService::MobileMenu' | abpLocalization }}</span>
    </a>

    @for (tab of navTabs2; track tab.link) {
      <a
        class="app-tab"
        [routerLink]="tab.link"
        routerLinkActive="selected"
        [routerLinkActiveOptions]="{ exact: tab.link === '/' }"
        (click)="closeMenu()"
      >
        @if (tab.icon) {
          <lpx-icon class="app-tab-icon" [iconClass]="tab.icon"></lpx-icon>
        }
        <span class="app-tab-text">{{ tabLabel(tab) | abpLocalization }}</span>
      </a>
    }
  </nav>

  <div class="lpx-mobile-menu" [hidden]="!menuVisible">
    <div class="lpx-logo-container"><app-logo></app-logo></div>
    <lpx-navbar-routes
      [navbarItems]="selectedMenuItems"
      [groupedItems]="groupedItems$ | async"
      (routeClick)="closeMenu()"
    >
    </lpx-navbar-routes>
  </div>
</div>
